import { useEffect, useState } from "react";
import { InfinityMark } from "../components/ConnectMyHubLogo";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Toaster } from "sonner";
import { LogOut, ShieldCheck, Clock, CheckCircle2, XCircle, PauseCircle } from "lucide-react";

const TONE = {
  PENDING_EMAIL:"bg-slate-100 text-slate-600 border-slate-200",
  PENDING_APPROVAL:"bg-amber-50 text-amber-800 border-amber-300",
  APPROVED:"bg-emerald-50 text-emerald-700 border-emerald-200",
  SUSPENDED:"bg-rose-50 text-rose-700 border-rose-200",
  REJECTED:"bg-slate-100 text-slate-600 border-slate-200",
};
const ICON = { PENDING_EMAIL: Clock, PENDING_APPROVAL: Clock, APPROVED: CheckCircle2, SUSPENDED: PauseCircle, REJECTED: XCircle };

export default function EmployerStatus() {
  const { user, logout } = useAuth();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/employer-portal/status").then(r=>{
    setS(r.data);
    if (r.data.user?.employer_status === "APPROVED") window.location.href = "/employer/dashboard";
  }).catch(()=>{}); }, []);
  if (!s) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Loading…</div>;
  const status = s.user?.employer_status || "PENDING_EMAIL";
  const Ic = ICON[status] || Clock;
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-slate-900 text-slate-100">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-slate-900 flex items-center justify-center"><InfinityMark size={22}/></div>
            <div><div className="font-display font-bold text-sm">ConnectMyHub™</div>
              <div className="text-[10px] text-slate-400 uppercase tracking-widest">Employer Portal</div></div>
          </div>
          <button onClick={logout} className="text-xs flex items-center gap-1 border border-slate-700 rounded-md px-3 py-1.5" data-testid="emp-logout"><LogOut size={12}/> Sign out</button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-sky-600 mb-1">Welcome, {user?.name}</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 mb-2">{s.company?.name || "Your company"}</h1>
        <p className="text-sm text-slate-500 mb-8">{s.company?.industry || "—"} · {s.company?.country || "—"}</p>

        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className={`w-11 h-11 rounded-lg flex items-center justify-center border ${TONE[status]}`}><Ic size={20}/></div>
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">Account status</div>
              <div className={`text-lg font-semibold ${status==="APPROVED"?"text-emerald-700":status==="REJECTED"||status==="SUSPENDED"?"text-rose-700":"text-slate-900"}`} data-testid="emp-status">{status.replace(/_/g," ")}</div>
            </div>
          </div>
          {status === "PENDING_EMAIL" && <p className="text-sm text-slate-700">Please check your email and complete verification.</p>}
          {status === "PENDING_APPROVAL" && (
            <div className="p-4 rounded-lg bg-amber-50 border border-amber-200 text-sm text-amber-900"><ShieldCheck size={14} className="inline mr-1"/> Your email is verified. A ConnectMyHub admin is reviewing your account. You'll receive access to the Employer Dashboard, Talent Network, and Smart Job Builder as soon as you're approved.</div>
          )}
          {status === "APPROVED" && (
            <div className="p-4 rounded-lg bg-emerald-50 border border-emerald-200 text-sm text-emerald-900">You're approved. Employer Dashboard, Smart Job Builder, and Talent Network access will be available in Wave 2.</div>
          )}
          {status === "SUSPENDED" && (
            <div className="p-4 rounded-lg bg-rose-50 border border-rose-200 text-sm text-rose-900">Your account is currently suspended. Please contact ConnectMyHub for details.{s.company?.last_action_reason?` Reason: ${s.company.last_action_reason}`:""}</div>
          )}
          {status === "REJECTED" && (
            <div className="p-4 rounded-lg bg-slate-100 border border-slate-200 text-sm text-slate-700">Your application was not approved.{s.company?.last_action_reason?` Reason: ${s.company.last_action_reason}`:""}</div>
          )}
        </div>
      </main>
      <Toaster position="top-right" richColors/>
    </div>
  );
}
